import { get } from 'lodash';

const styles = ({ padding, color }) => ({
  outerContainer: {
    color: get(color, 'bodyText'),
    padding: '3rem',
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "flex-start",
  },
  contentContainer: {
    width: '35%',
    backgroundColor: get(color, 'white'),
    border: `1px solid ${color.grayBorder}`,
    paddingTop: get(padding, 'p36'),
    padding: "48px",
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& img': {
      maxWidth: '100%',
      maxHeight: '100%',
      height: '100px',
    },
  },
  alternateLogo: {
    marginBottom: 0,
  },
  headerText: {
    marginTop: "12px",
    marginBottom: 0,
    textAlign: 'center',
  },
  fieldContainer: {
    marginTop: "24px !important",
    marginBottom: "24px !important",
  },
  textField: {
    paddingTop: '2px !important',
    paddingBottom: '0px !important',
  },
  termsOfUse: {
    marginTop: '-9px',
    "& .MuiCheckbox-root": {
      paddingRight: '4px',
    },
  },
  termsOfUseLabel: {
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    "& button": {
      paddingLeft: '4px',
    },
  },
  termsOfUseButton: {
    '&:focus': {
      border: `1px solid ${get(color, 'primaryButtonBackground')}`,
    },
  },
  termsofUseError: {
    color: `${get(color, 'error')}`,
    fontSize: '0.75rem',
    marginBottom: '24px',
    visibility: 'hidden',
  },
  showTermsofUseError: {
    visibility: 'visible',
  },
  actionButtons: {
    display: 'flex',
    flexDirection: 'column',
    gap: get(padding, 'p12'),
  },
  submitButton: {
    '&:focus': {
      border: `1px solid #FFFFFF`,
      outline: `1px solid ${get(color, 'primaryButtonBackground')}`,
    },
  },
  cancelButton: {
    '&:focus': {
      border: `3px double ${get(color, 'primaryButtonBackground')}`,
    },
  },
  notification: {
    top: 14,
  },
  formDialog: {
    width: 400,
  },
  formDialogDescription: {
    marginTop: 20,
  },
});
export default styles;
